/* ============================= */
/* VERSION V1.1 - FLOATING BUTTONS */
/* ============================= */

import React, { useState, useEffect } from "react";
import "../styles/FloatingButtons.css";

const FloatingButtons = () => {

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 350);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="floating-buttons">

      {/* APPEL */}
      <a
        href="tel:+33749424919"
        className="floating-call"
        aria-label="Appeler Taxi de la Douce"
      >
        📞
      </a>

      {/* RETOUR HAUT */}
      {visible && (
        <button
          className="floating-top"
          onClick={scrollTop}
          aria-label="Retour en haut"
        >
          ↑
        </button>
      )}

    </div>
  );
};

export default FloatingButtons;